import { render, staticRenderFns } from "./NavMicro.vue?vue&type=template&id=53af6983&scoped=true"
import script from "./NavMicro.vue?vue&type=script&lang=js"
export * from "./NavMicro.vue?vue&type=script&lang=js"
import style0 from "./NavMicro.vue?vue&type=style&index=0&id=53af6983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af6983",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationFullDropdown: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/Navigation/NavigationFullDropdown.vue').default})
